export default __webpack_public_path__ + "b28884ade8ffb63c9957843e3c9a19f0.png";